/**
 * The SMS consent wording. Shown next to the checkbox, stored with the opt-in, and repeated verbatim on the public
 * program page (/legal/sms.html) for carrier review. A test keeps the two in sync.
 */
export const SMS_CONSENT_TEXT =
  'I agree to receive automated text messages from flow (operated by Richard Clayton) with alerts about my debate tournament schedule and judging assignments, at the phone number above. Message frequency varies, typically fewer than 20 messages per tournament day. Msg & data rates may apply. Reply STOP to opt out at any time, or HELP for help. Consent is not a condition of any purchase.';
